module.exports = __webpack_public_path__ + "82b5821cfb4e7515f8c1d56a5d7c6442.svg";